import React from 'react';
import { Helmet } from 'react-helmet-async';

function CookiePolicy() {
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '60px 20px' }}>
      <Helmet>
        <title>Cookie Policy | Giovanni Rampazzo</title>
        <meta name="description" content="Informativa sull'utilizzo dei cookie" />
      </Helmet>

      <h1 style={{ marginBottom: '20px' }}>Cookie Policy</h1>
      <p style={{ color: 'var(--text-sub)', marginBottom: '40px' }}>
        Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
      </p>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>1. Cosa sono i Cookie</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti un sito web.
          Vengono utilizzati per far funzionare il sito in modo efficiente, migliorare l'esperienza di navigazione
          e fornire informazioni ai proprietari del sito.
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>2. Tipologie di Cookie Utilizzati</h2>

        <div style={{ marginBottom: '30px', padding: '20px', background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', color: 'var(--accent)' }}>
            Cookie Tecnici Essenziali
          </h3>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginBottom: '10px' }}>
            Necessari per il funzionamento del sito. Non possono essere disabilitati.
          </p>
          <ul style={{ color: 'var(--text-sub)', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li><strong>cookieConsent:</strong> memorizza le tue preferenze sui cookie</li>
            <li><strong>theme:</strong> salva la preferenza tema chiaro/scuro</li>
          </ul>
          <p style={{ color: 'var(--text-sub)', fontSize: '0.9rem', marginTop: '10px' }}>
            <strong>Durata:</strong> 12 mesi<br />
            <strong>Titolare:</strong> Giovanni Rampazzo
          </p>
        </div>

        <div style={{ marginBottom: '30px', padding: '20px', background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', color: 'var(--accent)' }}>
            Cookie Analytics (opzionali)
          </h3>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginBottom: '10px' }}>
            Utilizzati per raccogliere informazioni su come i visitatori utilizzano il sito.
            I dati vengono raccolti in forma anonima con IP anonimizzato.
          </p>
          <ul style={{ color: 'var(--text-sub)', lineHeight: '1.8', paddingLeft: '20px', marginBottom: '10px' }}>
            <li><strong>Google Analytics 4 (GA4):</strong> tracciamento visite, pagine visualizzate, durata sessione</li>
            <li><strong>Cookie:</strong> _ga, _ga_*, _gid</li>
            <li><strong>Anonimizzazione IP:</strong> attiva per conformità GDPR</li>
          </ul>
          <p style={{ color: 'var(--text-sub)', fontSize: '0.9rem', marginTop: '10px' }}>
            <strong>Durata:</strong> 24 mesi<br />
            <strong>Titolare:</strong> Google LLC<br />
            <strong>Privacy Policy:</strong>{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>
              policies.google.com/privacy
            </a>
          </p>
        </div>

        <div style={{ marginBottom: '30px', padding: '20px', background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', color: 'var(--accent)' }}>
            Cookie Marketing (opzionali)
          </h3>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginBottom: '10px' }}>
            Utilizzati per mostrare annunci pubblicitari personalizzati in base ai tuoi interessi.
          </p>
          <p style={{ color: 'var(--text-sub)', fontSize: '0.9rem', marginTop: '10px' }}>
            <strong>Durata:</strong> variabile (fino a 24 mesi)<br />
            <strong>Titolare:</strong> Google Ads (se attivato)
          </p>
        </div>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>3. Cookie di Terze Parti</h2>

        <div style={{ marginBottom: '20px', padding: '20px', background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h3 style={{ fontSize: '1.2rem', marginBottom: '10px' }}>Google reCAPTCHA Enterprise</h3>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
            Utilizziamo reCAPTCHA Enterprise di Google per proteggere il nostro modulo di contatto da spam e bot.
            reCAPTCHA raccoglie informazioni hardware e software, come dati del dispositivo e dell'applicazione,
            e le invia a Google per l'analisi.
          </p>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginTop: '10px' }}>
            <strong>Finalità:</strong> protezione anti-spam e sicurezza<br />
            <strong>Privacy Policy:</strong>{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>
              policies.google.com/privacy
            </a>
          </p>
        </div>

        <div style={{ marginBottom: '20px', padding: '20px', background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h3 style={{ fontSize: '1.2rem', marginBottom: '10px' }}>Hugging Face AI</h3>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
            Il chatbot "Tanjie" utilizza l'API di Hugging Face per fornire risposte automatiche.
            Le conversazioni vengono processate tramite i server di Hugging Face ma non vengono memorizzate permanentemente.
          </p>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginTop: '10px' }}>
            <strong>Finalità:</strong> assistente virtuale AI<br />
            <strong>Privacy Policy:</strong>{' '}
            <a href="https://huggingface.co/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>
              huggingface.co/privacy
            </a>
          </p>
        </div>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>4. Come Gestire i Cookie</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginBottom: '15px' }}>
          Puoi gestire le tue preferenze sui cookie in diversi modi:
        </p>

        <div style={{ marginBottom: '20px', padding: '20px', background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h3 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>Tramite il Banner Cookie</h3>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
            Alla prima visita, ti viene mostrato un banner che ti permette di accettare, rifiutare
            o personalizzare i cookie. Puoi modificare le tue preferenze in qualsiasi momento
            cancellando i dati del browser e visitando nuovamente il sito.
          </p>
        </div>

        <div style={{ marginBottom: '20px', padding: '20px', background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h3 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>Tramite il Browser</h3>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginBottom: '10px' }}>
            La maggior parte dei browser ti permette di:
          </p>
          <ul style={{ color: 'var(--text-sub)', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>Visualizzare i cookie presenti</li>
            <li>Bloccare tutti i cookie</li>
            <li>Bloccare i cookie di terze parti</li>
            <li>Cancellare tutti i cookie quando chiudi il browser</li>
          </ul>
          <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginTop: '10px', fontSize: '0.9rem' }}>
            <strong>Nota:</strong> disabilitare i cookie tecnici potrebbe compromettere il corretto funzionamento del sito.
          </p>
        </div>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>5. Link Utili per la Gestione dei Cookie</h2>
        <ul style={{ color: 'var(--text-sub)', lineHeight: '2', paddingLeft: '20px' }}>
          <li>
            <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>
              Google Chrome
            </a>
          </li>
          <li>
            <a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>
              Mozilla Firefox
            </a>
          </li>
          <li>
            <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>
              Safari
            </a>
          </li>
          <li>
            <a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>
              Microsoft Edge
            </a>
          </li>
        </ul>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>6. Aggiornamenti</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          Questa Cookie Policy può essere aggiornata periodicamente. Ti invitiamo a consultare
          regolarmente questa pagina per rimanere informato su come utilizziamo i cookie.
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>7. Contatti</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          Per qualsiasi domanda relativa all'utilizzo dei cookie, contatta:<br /><br />
          <strong>Giovanni Rampazzo</strong><br />
          Email: <a href="mailto:info@giovannirampazzo.com" style={{ color: 'var(--accent)' }}>info@giovannirampazzo.com</a>
        </p>
      </section>
    </div>
  );
}

export default CookiePolicy;
